import React, { createContext, useCallback, useState } from "react";
import { LoadingSplash } from "./LoadingSplash";
import {
  LoadingSplashOverlayContext as LoadingSplashOverlayContextType,
  LoadingSplashOverlayProviderProps,
} from "./LoadingSplashOverlayProvider.Parts";

export const LoadingSplashOverlayContext =
  createContext<LoadingSplashOverlayContextType>({
    addLoadingSplash: () => null,
    removeLoadingSplash: () => null,
  });

export const LoadingSplashOverlayProvider: React.FC<
  LoadingSplashOverlayProviderProps
> = ({ children }) => {
  const [loadingSplash, setLoadingSplash] = useState<{
    displayed: boolean;
    opaque?: boolean;
  }>({ displayed: false, opaque: true });

  const addLoadingSplash: LoadingSplashOverlayContextType["addLoadingSplash"] =
    useCallback(
      (opaque?: boolean) => {
        setLoadingSplash({ displayed: true, opaque: opaque });
      },
      [setLoadingSplash],
    );

  const removeLoadingSplash: LoadingSplashOverlayContextType["removeLoadingSplash"] =
    useCallback(() => {
      setLoadingSplash({ displayed: false });
    }, [setLoadingSplash]);

  return (
    <LoadingSplashOverlayContext.Provider
      value={{ addLoadingSplash, removeLoadingSplash }}
    >
      {loadingSplash.displayed && (
        <LoadingSplash overlay={true} opaque={loadingSplash.opaque} />
      )}
      {children}
    </LoadingSplashOverlayContext.Provider>
  );
};
